/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryConfig
 */
export interface DeliveryConfig {
    /**
     * 
     * @type {Array<number>}
     * @memberof DeliveryConfig
     */
    supportedParishes?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeliveryConfig
     */
    excludedTowns?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryConfig
     */
    knutsfordActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryConfig
     */
    zipMailActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryConfig
     */
    inHouseActive?: boolean;
    localDeliveryActive?: boolean;
    localDeliveryPricingType?: string;
    localDeliveryFlatRate?: number;
    localDeliveryPerKm?: number;
    localDeliveryBaseRate?: number;
    localDeliveryMaxDistance?: number;
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryConfig
     */
    courierId?: number;
}

/**
 * Check if a given object implements the DeliveryConfig interface.
 */
export function instanceOfDeliveryConfig(value: object): value is DeliveryConfig {
    return true;
}

export function DeliveryConfigFromJSON(json: any): DeliveryConfig {
    return DeliveryConfigFromJSONTyped(json, false);
}

export function DeliveryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'supportedParishes': json['supportedParishes'] == null ? undefined : json['supportedParishes'],
        'excludedTowns': json['excludedTowns'] == null ? undefined : json['excludedTowns'],
        'knutsfordActive': json['knutsfordActive'] == null ? undefined : json['knutsfordActive'],
        'zipMailActive': json['zipMailActive'] == null ? undefined : json['zipMailActive'],
        'inHouseActive': json['inHouseActive'] == null ? undefined : json['inHouseActive'],
        'localDeliveryActive': json['localDeliveryActive'] == null ? undefined : json['localDeliveryActive'],
        'localDeliveryPricingType': json['localDeliveryPricingType'] == null ? undefined : json['localDeliveryPricingType'],
        'localDeliveryFlatRate': json['localDeliveryFlatRate'] == null ? undefined : json['localDeliveryFlatRate'],
        'localDeliveryPerKm': json['localDeliveryPerKm'] == null ? undefined : json['localDeliveryPerKm'],
        'localDeliveryBaseRate': json['localDeliveryBaseRate'] == null ? undefined : json['localDeliveryBaseRate'],
        'localDeliveryMaxDistance': json['localDeliveryMaxDistance'] == null ? undefined : json['localDeliveryMaxDistance'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function DeliveryConfigToJSON(json: any): DeliveryConfig {
    return DeliveryConfigToJSONTyped(json, false);
}

export function DeliveryConfigToJSONTyped(value?: DeliveryConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'supportedParishes': value['supportedParishes'],
        'excludedTowns': value['excludedTowns'],
        'knutsfordActive': value['knutsfordActive'],
        'zipMailActive': value['zipMailActive'],
        'inHouseActive': value['inHouseActive'],
        'localDeliveryActive': value['localDeliveryActive'],
        'localDeliveryPricingType': value['localDeliveryPricingType'],
        'localDeliveryFlatRate': value['localDeliveryFlatRate'],
        'localDeliveryPerKm': value['localDeliveryPerKm'],
        'localDeliveryBaseRate': value['localDeliveryBaseRate'],
        'localDeliveryMaxDistance': value['localDeliveryMaxDistance'],
        'id': value['id'],
        'courierId': value['courierId'],
    };
}

